import React, { Fragment, useState, useEffect } from "react";

//package import

import {
  Grid,
  Typography,
  useTheme,
  Box,
  Divider,
  TextField,
  Button,
  Backdrop,
  CircularProgress,
  Snackbar,
  Alert,
  Link,
  Modal,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { formControlClasses } from "@mui/material/FormControl";
import { Formik, Form } from "formik";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

//user import

import { addvalidation } from "../../Services/validations/login";
import { forgotPasswordSchema } from "../../Services/validations/SetPassword";

import { RoutesUrls, adminRoutes } from "../../Services/Routes/APP";
import { getDecodedToken } from "../../Services/Routes/APP/PrivateRoute";
import { useNavigate } from "react-router-dom";
import { API_URLS } from "../../Services/Routes/API";
import { headersPost } from "../../Services/API";
import { StorageKeys } from "../../Services/Storage";
import { USER_ROLES_ENUM } from "../../common/Enums";
import { Logo } from "../../Svg";

//constants

const initialValues = {
  email: "",
  password: "",
};

const initialValues1 = {
  email: "",
};

//component

const LoginPage = () => {
  //hooks

  // const ROOT_DOMAIN = "node-planner"; // lvh for local & node-planner for production
  const theme = useTheme();

  //states

  const [open, setOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [forgetPasswordModalOpen, setforgetPasswordModalOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  const navigate = useNavigate();

  // const redirectUser = (data) => {
  //   const newHostName = `${ROOT_DOMAIN}.me`; // .me for local & .com for production
  //   let path = "";
  //   const url_location = window.location;

  //   if (window.origin.includes("netlify")) {
  //     path = window.origin;
  //   } else {
  //     if (data?.domain) {
  //       path =
  //         url_location.protocol +
  //         "//" +
  //         data?.domain +
  //         "." +
  //         newHostName +
  //         ":" +
  //         url_location.port +
  //         "#";
  //     } else {
  //       path =
  //         url_location.protocol +
  //         "//" +
  //         newHostName +
  //         ":" +
  //         url_location.port +
  //         "#";
  //     }
  //   }

  //   if (data) {
  //     switch (data.role) {
  //       case USER_ROLES_ENUM.superAdmin:
  //         path = path + RoutesUrls?.admin + adminRoutes?.dashboard;
  //         break;
  //       case USER_ROLES_ENUM.ministry:
  //         path = path + RoutesUrls?.ministryAdmin + adminRoutes?.dashboard;
  //         break;
  //       case USER_ROLES_ENUM.state:
  //         path = path + RoutesUrls?.provinceAdmin + adminRoutes?.dashboard;
  //         break;
  //       case USER_ROLES_ENUM.district:
  //         path = path + RoutesUrls?.districtAdmin + adminRoutes?.dashboard;
  //         break;
  //       case USER_ROLES_ENUM.hospital:
  //         path = path + RoutesUrls?.pouAdmin + adminRoutes?.dashboard;
  //         break;
  //       default:
  //         path = path + RoutesUrls?.root;
  //         break;
  //     }

  //     window.location = path;
  //   }
  // };

  const getUrl = (token) => {
    const user = getDecodedToken(token);

    if (user) {
      switch (user?.role) {
        case USER_ROLES_ENUM.superAdmin:
          navigate(RoutesUrls?.admin + adminRoutes?.dashboard);
          break;
        case USER_ROLES_ENUM.ministry:
          navigate(RoutesUrls?.ministryAdmin + adminRoutes?.dashboard);
          break;
        case USER_ROLES_ENUM.state:
          navigate(RoutesUrls?.provinceAdmin + adminRoutes?.dashboard);
          break;
        case USER_ROLES_ENUM.district:
          navigate(RoutesUrls?.districtAdmin + adminRoutes?.dashboard);
          break;
        case USER_ROLES_ENUM.hospital:
          navigate(RoutesUrls?.pouAdmin + adminRoutes?.dashboard);
          break;
        default:
          navigate(RoutesUrls?.root);
          break;
      }
    }
  };

  //form submit

  const submitHandler = (values) => {
    const data = {
      user: {
        email: values?.email,
        password: values?.password,
      },
    };
    setOpen(true);

    headersPost(API_URLS?.LOGIN, data)
      .then((res) => {
        setOpen(false);

        if (res?.status === 200 && res?.data?.success) {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          localStorage.setItem(StorageKeys?.token, res?.data?.token);
          getUrl(res?.data?.token);
          // let user = undefined;
          // if (res?.data && res?.data?.token) {
          //   const url_location = window.location;
          //   let siteUrl = url_location.hostname.split('.');
          //   const subDomain = siteUrl[0];

          //   user = getDecodedToken(res?.data?.token);
          //   if (user?.domain) {
          //     if (user?.domain === subDomain) {
          //       localStorage.setItem(StorageKeys?.token, res?.data?.token);
          //     }
          //   } else if (user?.role === USER_ROLES_ENUM.superAdmin && ("www" === subDomain || subDomain === ROOT_DOMAIN)) {
          //     localStorage.setItem(StorageKeys?.token, res?.data?.token);
          //   }

          //   redirectUser(user);
          // }
        } else {
          if (res?.data?.valid_link) {
            setAlertMsg(
              <div>
                {res?.data?.message}
                <Link
                  href={`${res?.data?.valid_link}`}
                  sx={{
                    textDecoration: "none",
                    display: !!res?.data?.valid_link,
                  }}
                >
                  {" Click here to login on your domain!"}
                </Link>
              </div>
            );
          } else {
            setAlertMsg(res?.data?.message);
          }
          setAlertOpen(true);
          setAlertIcon("warning");
          localStorage.clear();
        }
      })
      .catch((err) => {
        const { response } = err;
        setOpen(false);
        setAlertOpen(true);
        setAlertMsg(response?.statusText);
        setAlertIcon("error");
        localStorage.clear();
      });
  };

  // close snackbar

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setAlertOpen(false);
  };

  useEffect(() => {
    const token = localStorage.getItem(StorageKeys?.token);
    if (token && token !== "") {
      getUrl(token);
    }
  }, []);

  const formSubmitHandler = (values) => {
    const data = {
      email: values.email,
    };
    setOpen(true);

    headersPost(API_URLS?.FORGOT_PASSWORD, data)
      .then((res) => {
        setOpen(false);

        if (res?.status === 200 && res?.data?.success) {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          setTimeout(() => {
            navigate(RoutesUrls?.root);
          }, 100);
        } else {
          setOpen(false);
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        const { response } = err;
        setOpen(false);
        setAlertOpen(true);
        setAlertMsg(response?.statusText);
        setAlertIcon("error");
      });
  };

  // forgot password modal handlers

  const passwordHandler = () => {
    setforgetPasswordModalOpen(true);
  };
  const fogetPasswordHandlerClose = () => {
    setforgetPasswordModalOpen(false);
  };

  //render

  return (
    <Fragment>
      <Grid container>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          sx={{
            minHeight: { xs: "35vh", sm: "35vh", md: "100vh", lg: "100vh" },
            width: "100%",
            background: theme.palette.info.light,
          }}
        >
          <Box
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            flexDirection={"column"}
            height={"100%"}
            width={"100%"}
          >
            <Box mb={5}>
              <Logo />
            </Box>
            <Box>
              <Typography variant="h3" color={"white"} sx={{ fontWeight: 700 }}>
                Lets Get
              </Typography>
              <Typography
                variant="h3"
                color={"white"}
                sx={{ fontWeight: 700, marginTop: -1.5 }}
              >
                Vaccinated
              </Typography>
              <Typography variant="h6" color={"white"}>
                Lets save the world.
              </Typography>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <Box
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            flexDirection={"column"}
            height={"100%"}
            width={"100%"}
          >
            <Box padding={3}>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 600,
                  color: theme.palette.common.black,
                }}
              >
                Login to node planner
              </Typography>
              <Divider
                variant="middle"
                sx={{
                  width: "80%",
                  marginTop: theme.spacing(2),
                  marginLeft: theme.spacing(2.5),
                  border: "0.3px solid rgba(0, 0, 0, 0.7)",
                }}
              />

              <Formik
                initialValues={initialValues}
                validationSchema={addvalidation}
                onSubmit={submitHandler}
              >
                {({ values, errors, touched, handleChange, handleSubmit }) => (
                  <Form onSubmit={handleSubmit}>
                    <Box
                      display={"flex"}
                      justifyContent={"center"}
                      alignItems={"center"}
                      flexDirection={"column"}
                      sx={{
                        "& > :not(style)": { m: 1, width: "25ch" },
                        mt: "2rem",
                      }}
                    >
                      <TextField
                        name="email"
                        placeholder="E-mail"
                        variant="outlined"
                        value={values?.email}
                        error={touched?.email && Boolean(errors?.email)}
                        helperText={touched?.email && errors?.email}
                        onChange={handleChange}
                        sx={{
                          border: "1px solid grey",
                          [`& .${outlinedInputClasses?.root}`]: {
                            borderRadius: theme.spacing(1),
                          },
                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                        }}
                      />
                      <TextField
                        name="password"
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        variant="outlined"
                        value={values?.password}
                        error={touched?.password && Boolean(errors?.password)}
                        helperText={touched?.password && errors?.password}
                        onChange={handleChange}
                        sx={{
                          border: "1px solid grey",
                          [`& .${outlinedInputClasses?.root}`]: {
                            borderRadius: theme.spacing(1),
                          },
                          [`&.${formControlClasses?.root}`]: {
                            border: "none",
                          },
                        }}
                        InputProps={{
                          // <-- This is where the toggle button is added.
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                              >
                                {showPassword ? (
                                  <Visibility sx={{ width: "19px" }} />
                                ) : (
                                  <VisibilityOff sx={{ width: "19px" }} />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                      <Box display={"flex"} justifyContent={"flex-end"}>
                        <Link
                          href="#"
                          underline="hover"
                          onClick={passwordHandler}
                          sx={{
                            fontSize: 12,
                            lineHeight: 0.5,
                            marginBottom: 2,
                          }}
                        >
                          {"Forgot Password?"}
                        </Link>
                      </Box>
                      <Button
                        variant="contained"
                        type="submit"
                        sx={{
                          borderRadius: theme.spacing(1),
                          height: theme.spacing(6),
                          maxWidth: "40%",
                        }}
                      >
                        Login
                      </Button>
                    </Box>
                  </Form>
                )}
              </Formik>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Modal
        open={forgetPasswordModalOpen}
        onClose={fogetPasswordHandlerClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          style={{
            position: "absolute",
            padding: theme.spacing(2),
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            boxShadow: 24,
            borderRadius: theme.spacing(1),
            display: "flex",
            flexDirection: "column",
            minWidth: 320,
            maxWidth: 350,
          }}
        >
          <Formik
            onSubmit={formSubmitHandler}
            initialValues={initialValues1}
            validationSchema={forgotPasswordSchema}
          >
            {({ values, touched, handleChange, handleSubmit, errors }) => (
              <Form onSubmit={handleSubmit}>
                <Box p={2}>
                  <Typography
                    display={"flex"}
                    justifyContent={"center"}
                    variant="h6"
                    component="h2"
                    sx={{ color: theme.palette.text.light, fontWeight: "bold" }}
                  >
                    Please Enter Your Email
                  </Typography>
                </Box>
                <Box padding={1}>
                  <TextField
                    fullWidth
                    name="email"
                    type={"email"}
                    placeholder="Enter your email"
                    variant="outlined"
                    value={values?.email}
                    error={touched?.email && Boolean(errors?.email)}
                    helperText={touched?.email && errors?.email}
                    onChange={handleChange}
                    sx={{
                      border: "1px solid grey",
                      [`& .${outlinedInputClasses?.root}`]: {
                        borderRadius: theme.spacing(1),
                      },
                      [`&.${formControlClasses?.root}`]: {
                        border: "none",
                      },
                    }}
                  ></TextField>
                </Box>
                <Box
                  padding={1}
                  display={"flex"}
                  justifyContent={"center"}
                  py={2}
                >
                  <Box width={"50%"}>
                    <Button
                      variant="contained"
                      type="submit"
                      fullWidth
                      sx={{
                        borderRadius: theme.spacing(1),
                        height: theme.spacing(6),
                      }}
                    >
                      Send Reset Link
                    </Button>
                  </Box>
                </Box>
              </Form>
            )}
          </Formik>
        </Box>
      </Modal>

      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </Fragment>
  );
};

export default LoginPage;
